import { NgModule } from '@angular/core';

import { StoreModule } from '@ngrx/store';
import * as fromAuth from './store/auth';

@NgModule({
	imports: [StoreModule.forFeature(fromAuth.featureKey, fromAuth.reducer)],
})
export class AuthStoreModule {}
